import { Component } from '@theme/component';

/**
 * Cart item bundle accordion
 *
 *
 * @typedef {Object} Refs
 * @property {HTMLButtonElement} toggle
 *
 * @extends {Component<Refs>}
 */

class WICartBundleAccordion extends Component {
    requiredRefs = ['toggle'];

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    toggleAccordion() {
        const isOpen = this.refs.toggle.dataset.state === 'open';
        if (isOpen) {
            this.refs.toggle.setAttribute('data-state', 'closed');
        } else {
            this.refs.toggle.setAttribute('data-state', 'open');
        }
    }
}

if (!customElements.get('wi-cart-bundle-accordion')) {
    customElements.define('wi-cart-bundle-accordion', WICartBundleAccordion);
}